import styled from 'styled-components';
import { asRem } from 'utils';
import { breakpoints } from 'components/Theme';

export default styled.div`
  &.library-initial-item--zpp-course {
    .library-initial-item__content {
      padding-top: ${asRem(12)};

      @media (min-width: ${breakpoints.md}) {
        padding-top: ${asRem(32)};
      }

      @media (min-width: ${breakpoints.lg}) {
        padding-top: ${asRem(38)};
      }
    }
  }
`;
